import type { Item } from '../../types/item';

import useData from '@blueshift-ui/fetch/dist/hooks/use-data';

interface UseItemParams {
  itemId: string;
}

function useItem({ itemId }: UseItemParams) {
  return useData<Item | null>({
    queryKey: ['get-item', itemId],
    request: {
      url: `/v1/items/${itemId}`,
    },
  });
}

export default useItem;
